(function () {
    'use strict';

    function informationPartQuestionSet(questionViewModelConfigurationService, notifyService, $rootScope, $timeout) {
        var controller = [
            '$scope', function ($scope) {
                this.addNewQuestion = function (newQuestion) {
                    $scope.questionSetData.Questions.push(newQuestion);
                }

                this.toggleAddQuestion = function () {
                    $scope.toggleAddQuestion();
                }
            }
        ];

        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/informationPartQuestionSet.html',
            scope: {
                identifier: '@',
                questionSetData: '=',
                parentData: '=',
                mode: '=?',
                canDelete: '=',
                removeQuestionSet: '&',
                syncQuestionSet: '&',
                reorderMode: '=',
                stateUpdatedEventName: '@',
                sessionEntity: '=?'
            },
            link: function (scope, element, attrs) {
                if (!attrs.mode) {
                    scope.mode = 'Editor';
                }

                scope.showPartners = !(scope.parentData.Id && scope.parentData.Id.indexOf('WorkflowInternalContents') > -1);

                scope.titleContext = '';
                scope.editTitleData = {
                    Title: '',
                    OriginalTitle: ''
                };

                scope.siblingNames = scope.parentData.InformationParts.filter(function (part) {
                    return !part.IsRemoved;
                }).map(function (p) { return p.Title; });

                scope.workflowTitleMode = scope.questionSetData.Access.Edit ? 'display': 'readonly';
                scope.editTitleData.Title = scope.questionSetData.Prompt;

                scope.editWorkflowTitle = function () {
                    scope.workflowTitleMode = 'edit';
                    scope.editTitleData.OriginalTitle = scope.editTitleData.Title;
                }

                scope.saveWorkflowTitle = function () {
                    scope.questionSetData.Prompt = scope.editTitleData.Title;
                    scope.updateText();
                    scope.editTitleData.OriginalTitle = scope.editTitleData.Title;
                    scope.workflowTitleMode = 'display';
                    notifyService.notify('The ' + scope.titleContext + ' title has been updated');
                }

                scope.cancelSaveWorkflowTitle = function () {
                    scope.workflowTitleMode = 'display';
                    scope.editTitleData.Title = scope.editTitleData.OriginalTitle;
                }

                scope.toggleDetails = function () {
                    scope.questionSetData.isCollapsed = !scope.questionSetData.isCollapsed;
                }

                scope.toggleEditPrompt = function (save) {
                    if (save) {
                        // wait until changes propagate
                        $timeout(function () {
                            scope.questionSetData.Prompt = scope.model.editedPrompt;
                            scope.syncQuestionSet();
                        }, 0);
                    }
                    scope.editingPrompt = !scope.editingPrompt;
                }

                function setHasAvailableContent() {
                    scope.hasAvailableContent = scope.questionSetData.Questions
                        .some(function (question) {
                            return !question.IsRemoved;
                        });
                }

                function mapData() {
                    scope.questionSetData.Questions.filter(function (question) {
                        return question.$type ===
                            "Ecap.Api.ViewModels.OptionsQuestionViewModel, Ecap.Api";
                    }).forEach(function (question) {
                        var selectedOption = question.Options.find(function (option) {
                            return option.IsSelected;
                        });

                        if (selectedOption) {
                            question.SelectedOption = selectedOption.Prompt;
                        }
                    });
                }

                scope.$on(scope.stateUpdatedEventName, function () {
                    setHasAvailableContent();
                });

                setHasAvailableContent();
                mapData();

                scope.hasNotesOrSharing = scope.questionSetData.Partners ||
                    scope.questionSetData.ProjectUnderwritingNotes;
                // Issue here is that the note we create is not saved
                // when we go to sync the question set, we need to
                // have a way to not write over those notes
                scope.$watch(function () { return scope.questionSetData.Questions; },
                    function (newVal, oldVal) {
                        if (newVal && oldVal) {
                            if (!angular.equals(newVal, oldVal)) {
                                // Make sure we match up the Title and Prompt for Options Questions
                                scope.questionSetData.Questions.filter(function (question) {
                                    return question.$type ===
                                        "Ecap.Api.ViewModels.OptionsQuestionViewModel, Ecap.Api";
                                }).forEach(function (question) {
                                    question.Options.forEach(function (option) {
                                        option.Title = option.Prompt;

                                        if (!question.IsMultiSelect) {
                                            option.IsSelected = (question.SelectedOption === option.Prompt);
                                        }
                                    });

                                });

                                scope.syncQuestionSet();
                            }
                        }
                    }, true);

                scope.onNoteAdded = function () {
                    scope.noteCount += 1;
                }

                scope.onNoteRemoved = function (noteId) {
                    var noteToRemoveIndex = scope.questionSetData.ProjectUnderwritingNotes.findIndex(function (note) {
                        return note.NoteId === noteId;
                    });

                    if (noteToRemoveIndex !== -1) {
                        scope.questionSetData.ProjectUnderwritingNotes.splice(noteToRemoveIndex, 1);
                    }
                    scope.noteCount -= 1;
                }

                scope.updateText = function () {
                    // This trick makes sure the model is updated before we actually send the update
                    $timeout(function () {
                        scope.syncQuestionSet();
                    }, 0);
                }

                scope.addQuestionIsActive = false;
                scope.toggleAddQuestion = function () {
                    scope.addQuestionIsActive = !scope.addQuestionIsActive;
                }

                scope.reorderQuestions = function (questionIndex) {
                    scope.questionSetData.Questions.splice(questionIndex, 1);
                    scope.syncQuestionSet();
                }

                scope.removeQuestion = function (questionIndex) {
                    scope.questionSetData.Questions[questionIndex].IsRemoved = true;
                    scope.syncQuestionSet();
                    notifyService.notify('You removed the question ' +
                        scope.questionSetData.Questions[questionIndex].Prompt);
                }

                scope.optionExists = function (questionIndex, optionPrompt) {
                    var question = scope.questionSetData.Questions[questionIndex];
                    return question.Options.find(function (option) {
                        return option.Prompt === optionPrompt && option.IsSelected;
                    });
                };

                scope.canReorder = false;

                $rootScope.$watch(function () { return scope.reorderMode },
                        function (newVal) { scope.canReorder = newVal; });
            },
            controller: controller
        };
    }

    informationPartQuestionSet.$inject = ['questionViewModelConfigurationService', 'notifyService', '$rootScope', '$timeout'];

    angular.module('ecap.common').directive('informationPartQuestionSet', informationPartQuestionSet);
})();

